export default __webpack_public_path__ + "static/media/cart.eb47c17a.svg";